import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
} from "@dndModels";

// import DandDCharacterUtilities from '../../../utilities/character_utilities';

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
// import DeleteButton from '../../../../../components/input/buttons/DeleteButton';

interface Props {
  char: Character;
}

// const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterTransformInput({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  // const [expanded, setExpanded] = useState("");

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className="header centered"
        size={12}>Transforms</Grid>
      { char.spirit.transform &&
        <>
          <Grid size={12}>
            <ToggleButtonBox
              name={`Show ${char.spirit.transform?.name??"Transform"}`}
              disabled={processing}
              value={char.use_transform}
              onToggle={() => {
                char.use_transform = !char.use_transform;
                char.subscription_holder.transformed();
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <ToggleButtonBox
              name="End Transform"
              value={false}
              disabled={processing}
              onToggle={() => {
                char.spirit.transform = null;
                char.changed();
                char.subscription_holder.transformed();
                setProcessing(true);
              }}
            />
          </Grid>
        </>
      }
    </Grid>
  );
}
